import { Env } from '@stencil/core';

export const resources = {

  dev: {
    firebaseConfig: {
      apiKey: "AIzaSyBZjGFGFZ7z543GvRo3SKCOOT8a7XmOCh4",
      authDomain: "tambr-widget-dev.web.app",
      projectId: "tambr-dev",
      storageBucket: "tambr-dev.appspot.com",
      messagingSenderId: "237487237945",
      appId: "1:237487237945:web:1fbbffa9b5e84aee1096e8",
      measurementId: "G-99JNPWNZR9"
    },
    stripePlatformId: "pk_test_NzvN61ecZHnD5xUir37ADZrm",
    appCheckTokenUrl: "https://us-central1-tambr-dev.cloudfunctions.net/appCheck_getWidgetToken"
  },
 
  prod: {
    firebaseConfig: {
      apiKey: "AIzaSyBXN1HgpqJxRAYHapWDRVvg08Fs7SGPU3g",
      authDomain: "tambr-widget-live.firebaseapp.com",
      projectId: "tambr-live",
      storageBucket: "tambr-live.appspot.com",
      messagingSenderId: "803832480052",
      appId: "1:803832480052:web:7d5603524a3cbf7ae52561",
      measurementId: "G-ZGHG3H7833"
    },
    stripePlatformId: "pk_live_51MRR0aCJnhL17BKVHmrMKj5NBmJwVr8O8Wa6yITzGKtHbWtYvKfgyixLgVYe2oDwgfeLnxMZQtgrVmOMgtmm6M8300rrGkSuAv",
    appCheckTokenUrl: "https://us-central1-tambr-live.cloudfunctions.net/appCheck_getWidgetToken"
  },

  demo: {
    firebaseConfig: {
      apiKey: "AIzaSyDDPCl3NQKDdDZ1fjIcW364sEH3Q616efQ",
      authDomain: "tambr-widget-demo.firebaseapp.com",
      projectId: "tambr-demo",
      storageBucket: "tambr-demo.appspot.com",
      messagingSenderId: "379112709044",
      appId: "1:379112709044:web:a9e0d39c495b23dedcf0e1",
      measurementId: "G-LWR99TLR40"
    },
    stripePlatformId: "pk_test_51Je0aRCkKyX0FNvpeHzWaEvSQ6seQZ6Hw5gmRn7ywi18RERtcKktQsbtChiw4GvNDjQ91VhSK4sbmCp1kQoD9Otw00ClujCksX",
    appCheckTokenUrl: "https://us-central1-tambr-demo.cloudfunctions.net/appCheck_getWidgetToken"
  }

}

export const environment = resources[Env.apiEnv];